<!-- Page Preloder -->
<div #divNavbarOculto class="divOcultoTamaño"></div>
<div id="mainMenu">
  <!-- Humberger Begin -->
  <div class="humberger__menu__overlay" (click)="toggleNavbar()"></div>
  <div class="humberger__menu__wrapper">
    <div class="humberger__close" (click)="toggleNavbar()">
      <i class="fa fa-remove"></i>
    </div>
    <div class="humberger__menu__logo">
      <a *ngIf="URL_LINK_LOGO" routerLink="home"><img class="imgLogo" src="{{LOGO}}" alt="logo"></a>
      <img *ngIf="!URL_LINK_LOGO" class="imgLogo" src="{{LOGO}}" alt="logo">
    </div>
    <nav class="humberger__menu__nav mobile-menu">
      <ul class="nav-list">
        <li (click)="toggleNavbar()" [class.active]="router.url==='/'"><a routerLink="" (click)="navegaInicio()"
            i18n="headerLiInicio|navegación inicio">INICIO</a></li>
        <li (click)="toggleNavbar()" [class.active]="router.url==='/portal'"
          *ngIf="verPortal && authService.isLoggedIn()">
          <a (click)="navegaPortal()" i18n="headerLiPortal|navegación portal">PORTAL</a>
        </li>
        <li (click)="toggleNavbar()" [class.active]="router.url==='/tienda'"><a routerLink="" (click)="navegaTienda()"
            i18n="headerLiTienda|navegación tienda">TIENDA</a></li>
        <li (click)="toggleNavbar()" [class.active]="router.url==='/compra'"
          *ngIf="authService.isLoggedIn() && pedidoService.cesta.length > 0">
          <a (click)="navegaCompra()" i18n="headerLiFinCompra|navegación fin compra">FINALIZAR COMPRA</a>
        </li>
      </ul>
    </nav>
    <div class="humberger__menu__cart" *ngIf="authService.isLoggedIn()">
      <ul *ngIf="authService.isLoggedIn() && router.url==='/tienda'">
        <li>
          <div ngbDropdown #listaDrop1="ngbDropdown" class="d-inline-block">
            <div (click)="VisibleCartFav();toggleNavbar()" #dropdownLista2 id="dropdownLista2" ngbDropdownToggle><a><i
                  class="fa fa-heart" *ngIf="router.url==='/tienda'"></i>
                <span class="icon-favorito">{{pedidoService.lista.length}}</span></a></div>
          </div>
        </li>
        <li>&nbsp; &nbsp;</li>
        <li>
          <div ngbDropdown #cestaDrop1="ngbDropdown" display="dynamic" class="d-inline-block">
            <div (click)="VisibleCart();toggleNavbar()" id="dropdownCesta1" ngbDropdownToggle><a><i
                  class="fa fa-shopping-cart" [@cestaAddEffect]=pedidoService.cestaAnimationStatus></i>
                <span class="icon-favorito">{{pedidoService.cesta.length}}</span></a></div>
          </div>
        </li>
      </ul>
      <div class="header__cart__price" *ngIf="authService.isLoggedIn()" i18n>Total:
        <span>{{pedidoService.pedido?.imp_fac_total}} €</span>
      </div>
    </div>
    <div class="humberger__menu__widget">
      <!-- <div class="header__top__right__language">
                  <img src="assets/img/language.png" alt="">
                  <div>English</div>
                  <span class="arrow_carrot-down"></span>
                  <ul>
                      <li><a href="#">Spanis</a></li>
                      <li><a href="#">English</a></li>
                  </ul>
              </div> -->
      <div class="d-inline-block" *ngIf="authService.isLoggedIn()">
        <!-- Botón para mostrar/ocultar el popup -->
        <div class="header__top__info__user__phone" (click)="togglePopupPhone()">
          <div class="header__top__right__info">
            <div class="header__top__right__info_user">
              <div *ngIf="authService.usuario!= null && authService.usuario.sucursal != null">
                <i class="fa-solid fa-location-dot"></i>&nbsp;
                {{ authService.usuario.razon_social }}&nbsp;
                {{ authService.usuario.codigo }}-
                {{ authService.usuario.sucursal }}&nbsp;
              </div>
              <div *ngIf="authService.usuario!=null && authService.usuario!.sucursal == null">
                <i class="fa-solid fa-location-dot"></i>&nbsp;
                {{ authService.usuario!.razon_social }}&nbsp;
                {{ authService.usuario!.codigo }}&nbsp;
              </div>
            </div>
            <div *ngIf="!isPopupPhoneVisible && userService.numElementosListUsr > 1">
              <i class="fa-solid fa-angle-down"></i>
            </div>
            <div *ngIf="isPopupPhoneVisible && userService.numElementosListUsr > 1">
              <i class="fa-solid fa-angle-up"></i>
            </div>
          </div>
        </div>
        <!-- Popup -->
        <div class="popup-menu-phone" *ngIf="isPopupPhoneVisible && userService.numElementosListUsr > 1"
          [ngStyle]="popupPositionPhone" (click)="$event.stopPropagation()">
          <div>
            <p style="font-size: 20px;"><b i18n>Selección de CLIENTE</b></p>
            <table class="header__popup__info">
              <tr>
                <td></td>
                <td>
                  <b i18n>
                    Cliente
                  </b>
                </td>
                <td>
                  <b i18n>
                    Pedido
                  </b>
                </td>
                <td>
                  <b i18n>
                    Fecha
                  </b>
                </td>
                <td>
                  <b i18n>
                    Ref
                  </b>
                </td>
                <td>
                  <b i18n>
                    Importe
                  </b>
                </td>
              </tr>
              <tr *ngFor="let usr of authService.usuarios; let i = index" (click)="userService.usrSelect = i"
                [class.selected]="userService.usrSelect === i">
                <td>
                  <input type="radio" name="uniqueSelection" [(ngModel)]="userService.usrSelect" [value]="i"
                    (click)="$event.stopPropagation()" />
                </td>
                <td *ngIf="usr.codigo !== null && usr.sucursal == null">
                  <b>{{usr.codigo}}</b>
                </td>
                <td *ngIf="usr.codigo !== null && usr.sucursal != null">
                  {{usr.codigo}} | {{usr.sucursal}}
                </td>
                <td *ngIf="usr.codigo === null">
                  -
                </td>
                <td *ngIf="usr.pedcc_pedido !== null">
                  {{usr.pedcc_pedido}}
                </td>
                <td *ngIf="usr.pedcc_pedido === null">
                  -
                </td>
                <td *ngIf="usr.pedcc_fecha !== null">
                  {{usr.pedcc_fecha | date: 'dd/MM/yyyy'}}
                </td>
                <td *ngIf="usr.pedcc_fecha === null">
                  -
                </td>
                <td *ngIf="usr.pedcc_referencia !== null">
                  {{usr.pedcc_referencia}}
                </td>
                <td *ngIf="usr.pedcc_referencia === null">
                  -
                </td>
                <td *ngIf="usr.pedcc_importe !== null">
                  {{usr.pedcc_importe}}
                </td>
                <td *ngIf="usr.pedcc_importe === null">
                  -
                </td>
              </tr>
            </table>
            <div style="margin-top: 20px;">
              <button i18n [disabled]="userService.usrSelect === null" (click)="onAcceptPhone();redirectTienda();"
                class="btn btn-primary" *ngIf="userService.numElementosListUsr > 1">
                Cambiar CLIENTE
              </button>
            </div>
          </div>

        </div>
      </div>
      <div class="header__top__right__auth">
        <!-- <a href="#"><i class="fa fa-user"></i> Login</a> -->
        <!-- Móvil -->
        <div ngbDropdown class="d-inline-block" *ngIf="authService.isLoggedIn()">

          <div id="dropdownUser" ngbDropdownToggle><i class="fa fa-user item-principal"></i>
            {{authService.usuario!.usuario}} </div>
          <div ngbDropdownMenu aria-labelledby="dropdownUser">
            <a class="dropdown-item" routerLink="/misPedidos" *ngIf="CLIENTE=='asg'">
              <span i18n><i class="fa fa-shopping-basket"></i> Mis pedidos</span>
            </a>
            <a class="dropdown-item" routerLink="/declaracion347" *ngIf="CLIENTE=='asg'">
              <span i18n><i class="fa fa-book"></i> Declaración 347</span>
            </a>
            <a class="dropdown-item">
              <span i18n (click)="onCambiaClave()"><i class="fa fa-key"></i> Cambiar contraseña</span>
            </a>
            <a class="dropdown-item" (click)="headerLogout()">
              <span i18n><i class="fa fa-eject"></i> Desconectar</span>
            </a>
            <a id="help__toggle" class="dropdown-item" (mouseover)="toggleHelpDropdown()"
              *ngIf="idVideo1 != '' || idVideo2 != ''">
              <span i18n><i class="fa-solid fa-lightbulb"></i> Ayuda y tutoriales</span>
            </a>

            <!-- Dropdown que se muestra solo cuando se hace clic en "Ayuda" -->
            <div class="dropdown-container" *ngIf="showDropdown" (mouseleave)="closeDropdown()">
              <div class="dropdown__ayuda" ngbDropdownMenu aria-labelledby="dropdownHelp">
                <a class="dropdown-item" (click)="verTutorial('ped')" *ngIf="idVideo1 != ''">
                  <span i18n><i class="fa fa-info-circle"></i>Tutorial Pedidos</span>
                </a>
                <a class="dropdown-item" (click)="verTutorial('port')" *ngIf="idVideo2 != ''">
                  <span i18n><i class="fa fa-info-circle"></i>Tutorial Portal</span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div ngbDropdown class="d-inline-block" *ngIf="! authService.isLoggedIn()">
          <div><a (click)="toggleNavbar();navegaLogin()" i18n><i class="fa fa-user"></i> Inicia sesión </a></div>
        </div>
      </div>
    </div>

    <div class="humberger__menu__contact">
      <!-- <ul>
        <li><i class="fa fa-envelope"></i> pedidos@asg-si.com</li>
        <li>Envio gratuito para pedidos de más de 10€</li>
      </ul> -->
    </div>
  </div>
  <!-- Humberger End -->
</div>

<!-- Header Section Begin -->
<header class="header">
  <div class="header__top">
    <div class="container">
      <div class="row header__top__info">
        <div class="col-lg-6 col-md-8">
          <nav class="header__menu">
            <ul>
              <li [class.active]="router.url==='/'" *ngIf="verHome"><a routerLink="" (click)="navegaInicio()"
                  i18n="headerLiInicio|navegación inicio">INICIO</a></li>
              <li [class.active]="router.url==='/portal'" *ngIf="verPortal && authService.isLoggedIn()"><a
                  (click)="navegaPortal()" i18n="headerLiPortal|navegación portal">PORTAL</a></li>
              <li [class.active]="router.url==='/tienda'"><a routerLink="" (click)="navegaTienda()"
                  i18n="headerLiTienda|navegación tienda">TIENDA</a></li>
              <li [class.active]="router.url==='/compra'"
                *ngIf="authService.isLoggedIn() && pedidoService.cesta.length > 0"><a (click)="navegaCompra()"
                  i18n="headerLiFinCompra|navegación fin compra">FINALIZAR COMPRA</a>
              </li>
            </ul>
          </nav>
        </div>
        <div class="col-lg-6 col-md-4">
          <div class="header__top__right">

            <div class="d-inline-block" *ngIf="authService.isLoggedIn()">
              <!-- Botón para mostrar/ocultar el popup en móvil-->
              <div class="header__top__info__user" (click)="togglePopup()">
                <div class="header__top__right__info">
                  <div class="header__top__right__info_user">
                    <div *ngIf="authService.usuario!.sucursal != null">
                      <i class="fa-solid fa-location-dot"></i>&nbsp;
                      {{ authService.usuario!.razon_social }}&nbsp;
                      {{ authService.usuario!.codigo }}-
                      {{ authService.usuario!.sucursal }}&nbsp;
                    </div>
                    <div *ngIf="authService.usuario!.sucursal == null">
                      <i class="fa-solid fa-location-dot"></i>&nbsp;
                      {{ authService.usuario!.razon_social }}&nbsp;
                      {{ authService.usuario!.codigo }}&nbsp;
                    </div>
                  </div>
                  <div *ngIf="!isPopupVisible && userService.numElementosListUsr > 1">
                    <i class="fa-solid fa-angle-down"></i>
                  </div>
                  <div *ngIf="isPopupVisible && userService.numElementosListUsr > 1">
                    <i class="fa-solid fa-angle-up"></i>
                  </div>
                </div>
              </div>
              <!-- Popup -->
              <div class="popup-menu" *ngIf="isPopupVisible && userService.numElementosListUsr > 1"
                [ngStyle]="popupPosition" (click)="$event.stopPropagation()">
                <div>
                  <p style="font-size: 20px;"><b i18n>Selección de CLIENTE</b></p>
                  <table class="header__popup__info">
                    <tr>
                      <td></td>
                      <td>
                        <b i18n>
                          Cliente
                        </b>
                      </td>
                      <td class="direccion">
                        <b i18n>
                          Dirección
                        </b>
                      </td>
                      <td>
                        <b i18n>
                          Almacén
                        </b>
                      </td>
                      <td>
                        <b i18n>
                          Pedido
                        </b>
                      </td>
                      <td>
                        <b i18n>
                          Fecha
                        </b>
                      </td>
                      <td>
                        <b i18n>
                          Ref
                        </b>
                      </td>
                      <td>
                        <b i18n>
                          Importe
                        </b>
                      </td>
                    </tr>
                    <tr *ngFor="let usr of authService.usuarios; let i = index" (click)="userService.usrSelect = i"
                      [class.selected]="userService.usrSelect === i">
                      <td>
                        <input type="radio" name="uniqueSelection" [(ngModel)]="userService.usrSelect" [value]="i"
                          (click)="$event.stopPropagation()" />
                      </td>
                      <td *ngIf="usr.codigo !== null && usr.sucursal == null">
                        <b>{{usr.codigo}}</b>
                      </td>
                      <td *ngIf="usr.codigo !== null && usr.sucursal != null">
                        {{usr.codigo}} {{usr.sucursal}}
                      </td>
                      <td *ngIf="usr.codigo === null">
                        -
                      </td>
                      <td class="direccion" *ngIf="usr.dir_etiqueta !== null && usr.nombre_comercial != null">
                        <b>{{usr.nombre_comercial}}</b><br><br>
                        {{usr.dir_etiqueta}}
                      </td>
                      <td *ngIf="usr.dir_etiqueta === null && usr.nombre_comercial != null">
                        {{usr.nombre_comercial}}
                      </td>
                      <td *ngIf="usr.dir_etiqueta != null && usr.nombre_comercial === null">
                        {{usr.dir_etiqueta}}
                      </td>
                      <td *ngIf="usr.dir_etiqueta === null && usr.nombre_comercial === null">
                        -
                      </td>
                      <td *ngIf="usr.alm_titulo !== null">
                        {{usr.alm_titulo}}
                      </td>
                      <td *ngIf="usr.pedcc_pedido !== null">
                        {{usr.pedcc_pedido}}
                      </td>
                      <td *ngIf="usr.pedcc_pedido === null">
                        -
                      </td>
                      <td *ngIf="usr.pedcc_fecha !== null">
                        {{usr.pedcc_fecha | date: 'dd/MM/yyyy'}}
                      </td>
                      <td *ngIf="usr.pedcc_fecha === null">
                        -
                      </td>
                      <td *ngIf="usr.pedcc_referencia !== null">
                        {{usr.pedcc_referencia}}
                      </td>
                      <td *ngIf="usr.pedcc_referencia === null">
                        -
                      </td>
                      <td *ngIf="usr.pedcc_importe !== null">
                        {{usr.pedcc_importe}}
                      </td>
                      <td *ngIf="usr.pedcc_importe === null">
                        -
                      </td>
                    </tr>
                  </table>
                  <div style="margin-top: 20px;">
                    <button i18n [disabled]="userService.usrSelect === null" (click)="onAccept();redirectTienda();"
                      class="btn btn-primary" *ngIf="userService.numElementosListUsr > 1">
                      Cambiar CLIENTE
                    </button>
                  </div>
                </div>

              </div>
            </div>

            <div class=" header__top__right__auth">

              <!-- <a href="#"><i class="fa fa-user"></i> Login</a> -->
              <div ngbDropdown class="d-inline-block" *ngIf="authService.isLoggedIn()">
                <div id="dropdownUser" ngbDropdownToggle><i class="fa fa-user item-principal"></i>
                  {{authService.usuario!.usuario}}</div>
                <div ngbDropdownMenu #dropdownMenu aria-labelledby="dropdownUser">
                  <a class="dropdown-item" routerLink="/misPedidos" *ngIf="CLIENTE=='asg'" (click)="handleMenuClick()">
                    <span i18n>
                      <i class="fa fa-shopping-basket"></i> Mis pedidos</span>
                  </a>
                  <a class="dropdown-item" routerLink="/declaracion347" *ngIf="CLIENTE=='asg'"
                    (click)="handleMenuClick()">
                    <span i18n><i class="fa fa-book"></i> Declaración 347</span>
                  </a>
                  <a class="dropdown-item" (click)="onCambiaClave(); handleMenuClick()">
                    <span i18n><i class="fa fa-key"></i> Cambiar contraseña</span>
                  </a>
                  <a class="dropdown-item" (click)="headerLogout(); handleMenuClick()">
                    <span i18n><i class="fa fa-eject"></i> Desconectar</span>
                  </a>
                  <!-- Botón de Ayuda que muestra el dropdown al hacer clic -->
                  <a id="help__toggle" *ngIf="idVideo1 != '' || idVideo2 != ''" class="dropdown-item"
                    (mouseover)="toggleHelpDropdown()">
                    <span i18n><i class="fa-solid fa-lightbulb"></i> Ayuda y tutoriales</span>
                  </a>

                  <!-- Dropdown que se muestra solo cuando se hace clic en "Ayuda" -->
                  <div class="dropdown-container" *ngIf="showDropdown" (mouseleave)="closeDropdown()">
                    <div class="dropdown__ayuda" ngbDropdownMenu aria-labelledby="dropdownHelp">
                      <a class="dropdown-item" (click)="verTutorial('ped')" *ngIf="idVideo1 != ''">
                        <span i18n><i class="fa fa-info-circle"></i> Tutorial Pedidos</span>
                      </a>
                      <a class="dropdown-item" (click)="verTutorial('port')" *ngIf="idVideo2 != ''">
                        <span i18n><i class="fa fa-info-circle"></i> Tutorial Portal</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div ngbDropdown class="d-inline-block" *ngIf="! authService.isLoggedIn()">
                <div (click)="navegaLogin()"><a><i class="fa fa-user item-principal"></i> Inicia
                    sesión</a></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Modal -->
  <div class="modal-fade" [ngClass]="{'modal-minimized': isMinimized}" id="videoModal" tabindex="-1"
    aria-labelledby="videoModalLabel" aria-hidden="true" [class.active]="showModal">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="videoModalLabel" *ngIf="!isMinimized">Video {{textVideo}}</h5>
          <div class="modal-actions">
            <!-- Botón para minimizar -->
            <button type="button" class="btn-minimize" (click)="minimizeModal()" [class.hide]="isMinimized"
              aria-label="Minimize">
              <i class="fa-solid fa-down-left-and-up-right-to-center"></i>
            </button>
            <button type="button" class="btn-maximize" (click)="restoreModal()" [class.show]="isMinimized"
              aria-label="Restore">
              <i class="fa-solid fa-up-right-and-down-left-from-center"></i>
            </button>

            <!-- Botón para cerrar -->
            <button type="button" class="btn-close" (click)="closeModal()" aria-label="Close">
              <i class="fa fa-times"></i>
            </button>
          </div>
        </div>
        <div class="modal-body">
          <div class="video-container">
            <!-- <iframe [src]="videoUrl" width="560" height="315" title="YouTube video player" frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen>
            </iframe> -->

          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container">
    <div class="header__cart__logo">
      <div class="col-lg-3 cols icon__logo" [ngStyle]="{'background-color': LOGO_BACKGROUND_COLOR }">
        <div class="humberger__open" (click)="toggleNavbar()" *ngIf="!navbarOpen">
          <i class="fa fa-bars"></i>
        </div>
        <div class="header__logo">
          @if (URL_LINK_LOGO) {
          <a target="_blank" href="{{URL_LINK_LOGO}}">
            <img id="logo-main" src="{{LOGO}}" alt="2">
          </a>
          } @else {
          <img id="logo-main" src="{{LOGO}}" alt="2">
          }
        </div>
      </div>

      <div class="col-lg-6 col-md-12 header__input__show">

        <div class="hero__search__form form-check-inline" *ngIf="router.url.indexOf('/tienda') !== -1">
          <div class="input-group-append">

            <button class="btn btn-buscar" type="button" (click)="onSearch()"><i
                class="fa-solid fa-magnifying-glass"></i></button>
            <button id="clean-bottom" class="btn btn-borrar" type="button"><i class="x-borrar" (click)="onClear()"><i
                  class="bi bi-x"></i></i></button>
          </div>
          <div class="input-group">
            <input type="text" class="form-control" aria-label="Buscar" (keypress)="onKeyPressSearch($event)"
              [(ngModel)]="articuloService.parametros.busca">

          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="header__cart text-left" *ngIf="authService.isLoggedIn() && router.url.indexOf('/tienda') !== -1">
          <ul>
            <li>
              <div ngbDropdown #listaDrop2="ngbDropdown" display="dynamic" class="d-inline-block">
                <div id="dropdownLista" ngbDropdownToggle>
                  <a><i (click)="VisibleCartFav()" class="fa fa-heart"></i> <span
                      class="icon-favorito">{{pedidoService.lista.length}}</span></a>
                </div>
                <div id="overlay" class="overlay" [class.active]="isCartVisibleFav" (click)="cierraMenuFav()"></div>
                <div id="productos-favoritos" class="favCarrito" [ngClass]="{'empty': pedidoService.cesta.length===0}"
                  aria-labelledby="dropdownLista" [class.visible]="isCartVisibleFav">
                  <div class="closeCart" (click)="cierraMenuFav()">
                    <i class="fa fa-remove"></i>
                  </div>
                  <div class="row m-3">
                    <div class="col-md-12 caja-total">
                      <label class="suCompra" i18n><i class="fa fa-heart"></i> Productos favoritos </label>
                    </div>
                  </div>
                  <div class="list-group">
                    <div class="row m-1 " *ngFor="let articulo of pedidoService.lista">
                      <div class="col-md-6">
                        <app-articulo-lista [articulo]="articulo"></app-articulo-lista>
                      </div>
                    </div>
                  </div>
                  <div class="row m-3">
                    <div class="col-md-12">
                      <div class="row m-3" *ngIf="pedidoService.lista.length === 0">
                        <div class="col-md-12">
                          <h5 i18n>No hay productos en la lista de favoritos</h5>
                        </div>
                      </div>
                      <button class="btn btn-secondary btn-block"
                        (click)="$event.stopPropagation(); listaDrop2.close();cierraMenuFav()" i18n>CONTINUAR</button>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li>&nbsp; &nbsp;</li>
            <li *ngIf="authService.isLoggedIn()">
              <div ngbDropdown #cestaDrop2="ngbDropdown" display="dynamic" class="d-inline-block">
                <div id="dropdownCesta2" ngbDropdownToggle>
                  <a><i (click)="VisibleCart()" class="fa fa-shopping-cart"
                      [@cestaAddEffect]=pedidoService.cestaAnimationStatus></i>
                    <span class="icon-favorito">{{pedidoService.cesta.length}}</span></a>
                </div>
                <div id="overlay" class="overlay" [class.active]="isCartVisible" (click)="cierraMenu()"></div>
                <div id="cesta-dropdown2" class="cestaCarrito" [class.visible]="isCartVisible"
                  [ngClass]="{'empty': pedidoService.cesta.length===0}" aria-labelledby="dropdownCesta2">
                  <div class="closeCart" (click)="cierraMenu()">
                    <i class="fa fa-remove"></i>
                  </div>
                  <div class="row m-3">
                    <div class="col-md-12 caja-total">
                      <label class="suCompra" i18n><i class="fa fa-shopping-bag"></i> Su compra </label>
                    </div>
                  </div>
                  <div class="row m-3">
                    <div class="col-md-12 p-2 d-none d-xl-flex d-lg-flex flex-row justify-content-between ">
                      <button class="btn btn-secondary btnContinuar"
                        (click)="$event.stopPropagation(); cestaDrop2.close(); cierraMenu();" i18n>SEGUIR
                        COMPRANDO</button>
                      <button class="btn btn-success btnContinuar"
                        *ngIf="authService.isLoggedIn() && pedidoService.cesta.length > 0"
                        (click)="$event.stopPropagation(); cestaDrop2.close(); navegaCompra(); cierraMenu();"
                        i18n>FINALIZAR
                        COMPRA</button>

                    </div>
                    <!-- update only phone screen BY CJ-->

                    <div class="col-md-12 p-2 justify-content-between d-block d-lg-none d-xl-none">
                      <button class="btn btn-secondary w-100 mt-2 mb-2"
                        (click)="$event.stopPropagation(); cestaDrop2.close(); cierraMenu();" i18n>SEGUIR
                        COMPRANDO</button>
                      <button class="btn btn-success w-100 mt-2 mb-2"
                        *ngIf="authService.isLoggedIn() && pedidoService.cesta.length > 0"
                        (click)="$event.stopPropagation(); cestaDrop2.close(); navegaCompra(); cierraMenu();"
                        i18n>FINALIZAR
                        COMPRA</button>
                    </div>
                  </div>
                  <div class="list-group">
                    <div class="row cesta-pedido" *ngFor="let articulo of pedidoService.cesta">
                      <div class="col-md-6">
                        <app-articulo-cesta [articulo]="articulo"></app-articulo-cesta>
                      </div>
                    </div>
                  </div>
                  <div class="row m-3" *ngIf="pedidoService.cesta.length === 0">
                    <div class="col-md-12">
                      <h5 i18n>No hay productos en la cesta de la compra</h5>
                    </div>
                  </div>
                  <div class="h-divider"></div>
                  <div class="col-12" *ngIf="!pedidoService.usuario?.impuestos">
                    <span class="text-right pr-2"
                      *ngIf="authService.isLoggedIn() && pedidoService.cesta.length > 0"><strong class="impTotal">Total:
                        {{pedidoService.pedido?.imp_fac_neto
                        | currency: 'EUR':'symbol':undefined:'es-ES'}}</strong></span>
                  </div>
                  <div class="col-12" *ngIf="pedidoService.usuario?.impuestos">
                    <span class="text-right pr-2"
                      *ngIf="authService.isLoggedIn() && pedidoService.cesta.length > 0"><strong class="impTotal">Total:
                        {{pedidoService.pedido?.imp_fac_total
                        | currency: 'EUR':'symbol':undefined:'es-ES'}}</strong></span>
                  </div>

                </div>
              </div>
            </li>
          </ul>
          <div i18n class="header__cart__price header__cart__price__hide"
            *ngIf="authService.isLoggedIn() && pedidoService.cesta.length > 0 && (router.url.indexOf('/tienda') !== -1)">
            Neto: <strong>{{pedidoService.pedido?.imp_fac_neto | currency:
              'EUR':'symbol':undefined:'es-ES'}}</strong>,
            Total: <strong>{{pedidoService.pedido?.imp_fac_total | currency:
              'EUR':'symbol':undefined:'es-ES'}}</strong>
          </div>
          <!-- Visualizacion en movil -->
          <div class=" header__cart__price header__cart__price__show"
            *ngIf="authService.isLoggedIn() && pedidoService.cesta.length > 0 && router.url==='/tienda'">
            <strong>{{pedidoService.pedido?.imp_fac_neto | currency: 'EUR':'symbol':undefined:'es-ES'}}</strong>/
            <strong>{{pedidoService.pedido?.imp_fac_total | currency: 'EUR':'symbol':undefined:'es-ES'}}</strong>
          </div>
        </div>
      </div>
    </div>
    <!-- MENU USUARIO EN MODO PHONE-->
    <!-- <div class="humberger__open" (click)="toggleNavbar()" *ngIf="!navbarOpen">
      <i class="fa fa-bars"></i>
    </div> -->
  </div>
  <ng-template #contentTemplate>
    <div>
      <p>Content</p>
      <p>Content</p>
    </div>
  </ng-template>
</header>
<!-- Header Section End -->

<!-- Cabecera fija al hacer scroll -->
<section id="section-search" class="hero">
  <div class="container">
    <div class="row">
      <!-- jjc 28.9.2021 comentado para ver si previene errores de carga en web carmona
      <div *ngIf="router.url==='/tienda' || (router.url==='/' && authService.isLoggedIn())" class="m-3 col-lg-12">
        <banner-slide-show></banner-slide-show>
      </div>
      -->

      <div class="col-12 div__barra__nav"
        *ngIf="router.url==='/tienda' || (router.url==='/' && authService.isLoggedIn())">
        <div class="hero__search">
          <div class="header__cart__logo">
            <div class="col-lg-3 logo-transaccion">
              <div class="logo-menu2" [ngStyle]="{'background-color': LOGO_BACKGROUND_COLOR }">
                <div class="header__logo">
                  <!---

                    Actualización 11-02-2022
                    Autor: Carlos Jordán
                    Requerimiento: apuntar a una nueva dirección por petición del cliente
                  -->
                  @if (URL_LINK_LOGO) {
                  <a target="_blank" href="{{URL_LINK_LOGO}}">
                    <img id="logo-main" src="{{LOGO}}" alt="">
                  </a>
                  } @else {
                  <img id="logo-main" src="{{LOGO}}" alt="">
                  }
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-12 busqueda__estatico header__input__show">

              <div class="hero__search__form form-check-inline">
                <div class="input-group-append">

                  <button class="btn btn-buscar" type="button" (click)="onSearch()"><i
                      class="fa-solid fa-magnifying-glass"></i></button>
                  <button id="clean-bottom" class="btn btn-borrar" type="button"><i class="x-borrar"
                      (click)="onClear()"><i class="bi bi-x"></i></i></button>
                  <!-- <button class="btn btn-normal" type="button" (click)="onClearFilters()"
                    *ngIf="articuloService.filtrosActivo()">
                    <i class="fa fa-filter item-principal" aria-hidden="true"></i></button>

                  <button class="btn btn-ligth" type="button" (click)="articuloService.reseteaSector()"
                    *ngIf="articuloService.sectorActivo"><i class="fa fa-bookmark item-principal"
                      aria-hidden=" true"></i></button> -->
                </div>
                <div class="input-group">
                  <input type="text" class="form-control" aria-label="Buscar" (keypress)="onKeyPressSearch($event)"
                    [(ngModel)]="articuloService.parametros.busca">

                </div>
              </div>
            </div>
            <div class="col-4 cart-transaccion" *ngIf="authService.isLoggedIn()">
              <div id="header__cart_fixed" class="header__cart text-left">
                <ul>
                  <li>
                    <div ngbDropdown #listaDrop2="ngbDropdown" display="dynamic" class="d-inline-block">
                      <div id="dropdownLista" ngbDropdownToggle>
                        <a><i (click)="VisibleCartFav()" class="fa fa-heart"></i> <span
                            class="icon-favorito">{{pedidoService.lista.length}}</span></a>
                      </div>
                      <div id="overlay" class="overlay" [class.active]="isCartVisibleFav" (click)="cierraMenuFav()">
                      </div>
                      <div id="productos-favoritos" class="favCarrito"
                        [ngClass]="{'empty': pedidoService.cesta.length===0}" aria-labelledby="dropdownLista"
                        [class.visible]="isCartVisibleFav">
                        <div class="closeCart" (click)="cierraMenuFav()">
                          <i class="fa fa-remove"></i>
                        </div>
                        <div class="row m-3">
                          <div class="col-md-12 caja-total">
                            <label class="suCompra" i18n><i class="fa fa-heart"></i> Productos favoritos </label>
                          </div>
                        </div>
                        <div class="list-group">
                          <div class="row m-1 " *ngFor="let articulo of pedidoService.lista">
                            <div class="col-md-6">
                              <app-articulo-lista [articulo]="articulo"></app-articulo-lista>
                            </div>
                          </div>
                          <div class="row m-3" *ngIf="pedidoService.lista.length === 0">
                            <div class="col-md-12">
                              <h5 i18n>No hay productos en la lista de favoritos</h5>
                            </div>
                          </div>
                        </div>
                        <div class="row m-3">
                          <div class="col-md-12">
                            <button class="btn btn-secondary btn-block"
                              (click)="$event.stopPropagation(); listaDrop2.close();cierraMenuFav()"
                              i18n>CONTINUAR</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li>&nbsp; &nbsp;</li>
                  <li>
                    <div class="d-inline-block" triggers="manual" placement="bottom">
                      <div ngbDropdown #cestaDrop1="ngbDropdown" display="dynamic" class="d-inline-block">
                        <div (click)="VisibleCart()" id="dropdownCesta1" ngbDropdownToggle><a><i
                              class="fa fa-shopping-cart" [@cestaAddEffect]=pedidoService.cestaAnimationStatus></i>
                            <span class="icon-favorito">{{pedidoService.cesta.length}}</span></a></div>
                      </div>
                      <ng-template #contentTemplate let-modal>
                        <div>
                          <div class="modal-header">
                            <i class="fa fa-shopping-cart"></i>
                            <span class="modal-title" i18n>Su compra:</span>
                            <span class="text-right mt-2 modal-price"
                              *ngIf="authService.isLoggedIn() && pedidoService.cesta.length > 0">
                              <strong>{{pedidoService.pedido?.imp_fac_total | currency:
                                'EUR':'symbol':undefined:'es-ES'}}</strong>
                            </span>
                          </div>
                          <div class="modal-body">
                            <ul class="list-group list-group-flush">
                              <li class="list-group-item-pop" *ngFor="let articulo of pedidoService.cesta">
                                <app-articulo-cesta [articulo]="articulo"></app-articulo-cesta>
                              </li>
                              <li i18n class="list-group-item-pop" *ngIf="pedidoService.cesta.length === 0">
                                No hay productos en la cesta de la compra
                              </li>
                            </ul>
                          </div>

                          <div class="modal-footer">
                            <button class="btn btn-secondary btn-sm" (click)="modal.dismiss()" i18n>CONTINUAR</button>
                            <button class="btn btn-success btn-sm"
                              *ngIf="authService.isLoggedIn() && pedidoService.cesta.length > 0"
                              (click)="modal.dismiss(); navegaCompra()" i18n>FINALIZAR</button>

                          </div>
                        </div>
                      </ng-template>
                    </div>
                  </li>
                </ul>
                <div class="header__cart__price" *ngIf="authService.isLoggedIn() && pedidoService.cesta.length > 0">
                  <!--neto/importe en barra de sectores-->
                  <strong>{{pedidoService.pedido?.imp_fac_neto | currency:
                    'EUR':'symbol':undefined:'es-ES'}}</strong>,
                  / <strong>{{pedidoService.pedido?.imp_fac_total | currency:
                    'EUR':'symbol':undefined:'es-ES'}}</strong>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-12 header__input__hide">

            <div class="hero__search__form form-check-inline" *ngIf="router.url==='/tienda'">
              <div class="input-group-append">

                <button class="btn btn-buscar" type="button" (click)="onSearch()"><i
                    class="fa-solid fa-magnifying-glass"></i></button>
                <button id="clean-bottom" class="btn btn-borrar" type="button"><i class="x-borrar"
                    (click)="onClear()"><i class="bi bi-x"></i></i></button>
                <!-- <button class="btn btn-normal" type="button" (click)="onClearFilters()"
                        *ngIf="articuloService.filtrosActivo()">
                        <i class="fa fa-filter item-principal" aria-hidden="true"></i></button>

                      <button class="btn btn-ligth" type="button" (click)="articuloService.reseteaSector()"
                        *ngIf="articuloService.sectorActivo"><i class="fa fa-bookmark item-principal"
                          aria-hidden=" true"></i></button> -->
              </div>
              <div class="input-group">
                <input type="text" class="form-control" aria-label="Buscar" (keypress)="onKeyPressSearch($event)"
                  [(ngModel)]="articuloService.parametros.busca">

              </div>
            </div>
          </div>
          <!-- barra sectores desktop-->
          <div id="arrowNavSec" #arrowNav class="navSec arrows-nav" *ngIf="router.url==='/tienda'">
            <button class="nav-arrow left-arrow" (click)="scrollNavBar('left')"><i
                class="fa-solid fa-arrow-left"></i></button>
            <button class="nav-arrow right-arrow" (click)="scrollNavBar('right')"><i
                class="fa-solid fa-arrow-right"></i></button>
          </div>
          <div class="container d-none d-lg-block d-xl-block" *ngIf="router.url==='/tienda'">
            <div class="row">
              <div #divNavbar class="col-lg-12">
                <nav class="header__sector text-center" [ngStyle]="{'background-color': SECTOR_BACKGROUND_COLOR}"
                  *ngIf="(AGRUPACION | uppercase) === 'SECTOR'">
                  <div #sectorNavbar class="navbar">
                    <ul>
                      <li *ngFor="let sector of articuloService.sectores"
                        [class.active]="articuloService.sectorActivo && sector.sector_id == articuloService.sectorActivo.sector_id">
                        <a data-toggle="tab" (click)="filtraSector(sector)">{{ sector.descripcion }}</a>
                      </li>
                    </ul>
                  </div>
                </nav>
                <nav class="header__sector text-center" [ngStyle]="{'background-color': SECTOR_BACKGROUND_COLOR}"
                  *ngIf="(AGRUPACION | uppercase) === 'SECCION'">
                  <div #seccionNavbar class="navbar nav_seccion">
                    <ul>
                      <li *ngFor="let seccion of articuloService.secciones"
                        [class.active]="articuloService.seccionActivo && seccion.sec_id == articuloService.seccionActivo.sec_id">
                        <a data-toggle="tab" (click)="filtraSeccion(seccion)">{{ seccion.descripcion }}</a>
                      </li>
                    </ul>
                  </div>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="col-2">
                <button class="btn " style="background: #2BBBAD; color: whitesmoke;" type="button" (click)="onClearFilters()">Limpiar filtros</button>
              </div> -->
      <div class="col-lg-12  d-none d-lg-block d-xl-block" style="background: #fff">&nbsp;</div>

    </div>


    <!-- <div *ngIf="VER_PROD_LOGOUT"><modal-promocion></modal-promocion></div> -->


  </div>
</section>
<!-- <div>ruta? {{router.url==='/'}} login? {{authService.isLoggedIn()}}</div>
  <div>{{router.url==='/' && authService.isLoggedIn()}}</div> -->
<!-- Hero Section End -->